import type { CreateUser, UpdateUser, User } from '@/types/user.types'
import { CLEVERLINK_API_BASE_URL, RESOURCES } from '@/constants/apiConstants'
import {
  resourceMutationWithBody,
  resourceWithPaginationAndSort,
} from '@/utils/apiUtils'

type RouteUserId = User['id'] | string

export const usersRoutes = {
  root: `${CLEVERLINK_API_BASE_URL}/${RESOURCES.USERS}`,
  list: () => usersRoutes.root,
  detail(userId: RouteUserId) {
    return `${usersRoutes.root}/${userId}`
  },
  edit: () => `${usersRoutes.root}/edit`,
  delete: () => `${usersRoutes.root}/delete`,
}

export const fetchUsers = resourceWithPaginationAndSort<User>(
  usersRoutes.list,
  'users',
)

type CreateUserResponse = { item: User }
type UpdateUsersPayload = { userIds: Array<number> } & UpdateUser
type DeleteUsersPayload = { userIds: Array<number>; reason: string }

const createUserRequest = resourceMutationWithBody<
  CreateUserResponse,
  CreateUser
>(usersRoutes.list, 'users', 'POST')

const updateUsersRequest = resourceMutationWithBody<
  Array<User>,
  UpdateUsersPayload
>(usersRoutes.edit, 'users', 'PATCH')

const deleteUsersRequest = resourceMutationWithBody<void, DeleteUsersPayload>(
  usersRoutes.delete,
  'users',
  'DELETE',
)

export const createUser = async (data: CreateUser): Promise<User> => {
  const response = await createUserRequest(data)
  return response.item
}

export const updateUsers = async (
  userIds: Array<number>,
  data: UpdateUser,
): Promise<Array<User>> => {
  return updateUsersRequest({ userIds, ...data })
}

export const deleteUsers = async (
  userIds: Array<number>,
  reason: string,
): Promise<void> => {
  await deleteUsersRequest({ userIds, reason })
}
